// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:56:11

export default {
  "id": "scroll-and-spot",
  "slug": "scroll-and-spot",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/23fa647cfc094a2cb1d367c988aa6024-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/23fa647cfc094a2cb1d367c988aa6024/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Scroll and Spot",
      "description": "Experience the joy of the holidays with Scroll and Spot, a unique Christmas-themed puzzle game! Explore two beautifully crafted images as you scroll to uncover five subtle differences hidden within.The scrolling feature keeps both images perfectly aligned, making it a dynamic and immersive puzzle experience. Challenge your observation skills and celebrate the holiday spirit with every discovery!\n",
      "instructions": "Drag the screen to scroll, tap to spot the differences, and find all 5 differences to advance to the next level!",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "christmas",
        "differences",
        "holiday",
        "skill",
        "winter"
      ]
    },
    "zh-CN": {
      "title": "滚动和寻找",
      "description": "与Scroll和Spot一起体验节日的乐趣，这是一款独特的圣诞主题益智游戏！探索两张精心制作的图片，滚动以揭示隐藏在其中的五个微妙差异。滚动功能确保两张图片始终完美对齐，使游戏体验充满活力和沉浸感。挑战你的观察能力，在每个发现中庆祝节日精神！",
      "instructions": "拖动屏幕进行滚动，轻触寻找不同之处，找到所有5处差异后进入下一关！",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "圣诞节",
        "差异",
        "假日",
        "技能",
        "冬季"
      ]
    },
    "zh-TW": {
      "title": "捲動並尋找",
      "description": "體驗Scroll和Spot帶來的節日歡樂，一款獨特的聖誕主題拼圖遊戲！探索兩幅精心製作的圖片，當你滑動時，將發現其中隱藏的五個細微差異。滑動功能能讓兩幅圖片保持完美對齊，使遊戲過程充滿動態和沉浸感。挑戰你的觀察力，並在每一次發現中慶祝節日氣氛！",
      "instructions": "將螢幕拉動以滾動，點擊以尋找差異，找到所有5個差異即可進入下一關！",
      "genres": [
        "休闲",
        "拼圖"
      ],
      "tags": [
        "聖誕節",
        "差異",
        "節日",
        "技能",
        "冬天"
      ]
    },
    "zh-HK": {
      "title": "捲動及尋找",
      "description": "體驗 Scroll 和 Spot 帶來的節日歡樂，一個獨特的聖誕主題拼圖遊戲！探索兩幅美麗的圖片，當你拖動時，可以發現圖片中藏有五個微妙的差異。拖動功能讓兩幅圖片始終保持精準對齊，提供一個動態且沉浸式的拼圖體驗。挑戰你的觀察力，並在每一次發現中慶祝節日氣氛！",
      "instructions": "拖曳螢幕以捲動，按鈕以尋找不同之處，找到所有5個不同之處以進入下一關！",
      "genres": [
        "輕鬆",
        "謎題"
      ],
      "tags": [
        "聖誕節",
        "差異",
        "節日",
        "技能",
        "冬季"
      ]
    },
    "ja": {
      "title": "スクロール＆スポット",
      "description": "ScrollとSpotで、ユニークなクリスマステーマのパズルゲームを楽しみましょう！二つの美しく作られた画像を探索しながら、スクロールして隠された5つの微妙な違いを見つけ出してください。スクロール機能は両画像を完璧に一致させ、ダイナミックで没入感のあるパズル体験を提供します。観察力を試しながら、発見ごとにホリデースピリットを祝ってください！",
      "instructions": "スクリーンをドラッグしてスクロールし、タップして違いを見つけ、5つの違いをすべて見つけて次のレベルに進む！",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "クリスマス",
        "違い",
        "休日",
        "スキル",
        "冬"
      ]
    },
    "ko": {
      "title": "스크롤하고 찾아보세요",
      "description": "Scroll과 Spot과 함께 특별한 크리스마스 테마의 파ズ르 게임으로 연말의 기쁨을 경험해보세요! 두 개의 아름다운 이미지를 탐험하면서 스크롤하여 숨겨진 다섯 가지 미묘한 차이점을 발견하세요. 스크롤 기능은 두 이미지를 완벽하게 일치시켜, 역동적이고 몰입감 있는 파ズ르 경험을 제공합니다. 관찰력을 도전하고, 발견마다 연말 분위기를 즐겨보세요!",
      "instructions": "화면을 드래그하여 스크롤하십시오, 차이점을 찾기 위해 탭하십시오, 5개의 차이점을 찾아 다음 레벨로 진행하세요!",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "クリ스마ス",
        "차이",
        "공휴일",
        "기술",
        "겨울"
      ]
    },
    "fr": {
      "title": "Faites défiler et trouvez",
      "description": "Profitez du bonheur des fêtes avec Scroll et Spot, un jeu de puzzle unique à thème de Noël ! Explorez deux images magnifiquement créées tout en glissant pour découvrir cinq différences subtiles cachées à l'intérieur. La fonction de défilement maintient les deux images parfaitement alignées, rendant l'expérience de puzzle dynamique et immersive. Défiez vos compétences d'observation et célébrez l'esprit des fêtes à chaque découverte !",
      "instructions": "Tirez sur l'écran pour faire défiler, appuyez pour trouver les différences et trouvez les 5 différences pour passer au niveau suivant !",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "Noël",
        "différences",
        "fête",
        "compétence",
        "hiver"
      ]
    }
  }
};
